import { commonConfig } from './common';

export const environment = {
  ...commonConfig,
  production: false,
  rbsConfig: {
    scope: 'rbs',
    clientId: 'FFmo6mYKqtobXrqWhvycVcfgRgegkhdF',
    grant_type: 'custom_castgc',
  },
};
